import objectFitImages from 'object-fit-images';

window.addEventListener(
  'load',
  () => {
    objectFitImages();
  },
  { once: true }
);
